import { registerSteps } from '@/mocks/home';

export default function HowToRegister() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 lg:px-10 max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-3">
            三步完成 2pg·com 注册
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            简单快捷的开户流程，最快30秒即可开始您的游戏之旅
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {registerSteps.map((step, index) => (
            <div key={index} className="relative text-center">
              <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-primary-500 text-background-50 text-2xl font-bold font-heading mb-5">
                {step.step}
              </div>
              <h3 className="text-lg font-bold font-heading text-foreground-900 mb-2">
                {step.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed max-w-xs mx-auto">
                {step.description}
              </p>
              {index < registerSteps.length - 1 && (
                <div className="hidden md:block absolute top-8 left-[calc(50%+3rem)] w-[calc(100%-6rem)]">
                  <div className="border-t-2 border-dashed border-primary-200"></div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}